// extracted by mini-css-extract-plugin
export default {"overview-title":"EstimateTasksTree_overview-title__RyP5G"};